import React, { useState } from 'react';
import { InputAdornment, TextField, Button } from '@material-ui/core';
import { translate } from 'react-i18next';
import { Search as SearchIcon } from '@material-ui/icons';
import './SubmittableSearchBar.scss';

/** @param {import('@material-ui/core').TextFieldProps} param0 */
const SubmittableSearchBar = ({ className, onChange = (val) => { }, t, ...props }) => {

    const [searchValue, setSearchValue] = useState("");

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            onChange(searchValue)
        }
    }

    return (
        <TextField
            size="small"
            variant="outlined"
            {...props}
            className={`${className || ''} submittable-search-bar `}
            placeholder={t('common.search')}
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            onKeyDown={handleKeyDown}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <SearchIcon />
                    </InputAdornment>
                ),
                endAdornment: (
                    <InputAdornment position="end">
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => onChange(searchValue)}
                        >
                            {t('common.search')}
                        </Button>
                    </InputAdornment>
                )
            }}
        />
    );
};

export default translate('common')(SubmittableSearchBar);
